import React from 'react';
import { CHART_X_LABEL, CHART_Y_LABEL } from '../costBenchmarkTexts.js';
import PropTypes from 'prop-types';
import { CHART_POSITION, FRAME_COLOR } from '../costBenchmarkHelpers.js';
import ChartDot from './ChartDot.js';
import Axis from './Axis.js';

const Chart = ({ xScale, yScale, xTicks, yTicks, dimensions, data, innerHeight, innerWidth, uniqueId }) => {

  return (
    <svg
      viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
      preserveAspectRatio="xMidYMid meet"
      width="100%"
      height={dimensions.height}
      className="d3-scatter-svg"
    >
      <g transform={`translate(${CHART_POSITION.left},${CHART_POSITION.top})`}>
        <rect width={innerWidth} height={innerHeight} fill="none" stroke={FRAME_COLOR} />
        <Axis ticks={yTicks} scale={yScale} orientation="y" innerWidth={innerWidth} innerHeight={innerHeight} />
        <Axis ticks={xTicks} scale={xScale} orientation="x" innerWidth={innerWidth} innerHeight={innerHeight} />
        <text 
          x={innerWidth / 2} 
          y={innerHeight + 50} 
          textAnchor="middle" 
          className="axis-label"
        >
          {CHART_X_LABEL}
        </text>
        <text
          transform="rotate(-90)"
          x={-innerHeight / 2}
          y={-50}
          textAnchor="middle"
          className="axis-label"
        >
          {CHART_Y_LABEL}
        </text>
        {data.map((d, i) => (
          <ChartDot key={d.id || i} data={d} x={xScale(d.peerMedian)} y={yScale(d.costPerCapita)} index={i} uniqueId={uniqueId} />
        ))}
      </g>
    </svg>
  );
};

Chart.displayName = 'Chart';

Chart.propTypes = {
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  xTicks: PropTypes.array.isRequired,
  yTicks: PropTypes.array.isRequired,
  dimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  innerHeight: PropTypes.number,
  innerWidth: PropTypes.number,
  uniqueId: PropTypes.string
};

export default Chart;
